export default "__VITE_ASSET__f4cf9ebd__"